import mixpanel from 'mixpanel-browser';

const MIXPANEL_TOKEN = process.env.REACT_APP_MIXPANEL_TOKEN;
const MIXPANEL_API_HOST = process.env.REACT_APP_MIXPANEL_API_HOST;
let initialized = false;

export function initMixpanel(): void {
	if (!MIXPANEL_TOKEN || initialized) return;
	try {
		mixpanel.init(MIXPANEL_TOKEN, {
			api_host: MIXPANEL_API_HOST || 'https://api-eu.mixpanel.com',
			debug: process.env.NODE_ENV === 'development',
			persistence: 'localStorage',
		});
		initialized = true;
	} catch (e) {
		console.warn('[Mixpanel] Init failed:', (e as Error).message);
	}
}

export function mpTrack(
	eventName: string,
	properties: Record<string, unknown> = {},
): void {
	if (!initialized) return;
	try {
		mixpanel.track(eventName, {
			...properties,
			timestamp: new Date().toISOString(),
		});
	} catch {
		/* silent */
	}
}

export function mpRegisterSuperProps(props: Record<string, unknown>): void {
	if (!initialized) return;
	try {
		mixpanel.register(props);
	} catch {
		/* silent */
	}
}

export function mpPeopleSet(props: Record<string, unknown>): void {
	if (!initialized) return;
	try {
		mixpanel.people.set(props);
	} catch {
		/* silent */
	}
}

export function mpPeopleSetOnce(props: Record<string, unknown>): void {
	if (!initialized) return;
	try {
		mixpanel.people.set_once(props);
	} catch {
		/* silent */
	}
}

export function mpPeopleIncrement(prop: string, by: number = 1): void {
	if (!initialized) return;
	try {
		mixpanel.people.increment(prop, by);
	} catch {
		/* silent */
	}
}

export function mpIdentify(
	userId: string,
	peopleProps: Record<string, unknown> = {},
	superProps: Record<string, unknown> = {},
): void {
	if (!initialized) return;
	try {
		mixpanel.identify(userId);
		if (Object.keys(superProps).length > 0) {
			mixpanel.register(superProps);
		}
		if (Object.keys(peopleProps).length > 0) {
			mixpanel.people.set(peopleProps);
		}
	} catch {
		/* silent */
	}
}

export function mpReset(): void {
	if (!initialized) return;
	try {
		mixpanel.reset();
	} catch {
		/* silent */
	}
}
